module["exports"] = [
  "#####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/uk/address/postcode.js
// module id = 2149
// module chunks = 0